"use client";

import Link from "next/link";
import { CardHeader } from "@/components/ui/card";
import Gallery from "./Gallery";
import ProductTag from "@/components/CustomUI/modules/ProductTag";
import WishlistButton from "@/components/CustomUI/modules/WishlistButton";
import { generalEcomEvent } from "@/lib/utils";

const Header = ({ 
  name, pdp_url, images, card_tags, 
  pk, price, category 
}) => {

  const handleClick = () => {
    generalEcomEvent({
      event: "select_item",
      items: [
        {
          item_name: name,
          item_id: pk,
          price: price,
          item_category: category?.name,
        },
      ],
    });
  }

  return (
    <CardHeader className="p-0 space-y-0">
      <Link 
        href={pdp_url} 
        className="relative w-full h-full"
        aria-label={"product details of " +  name}
        onClick={handleClick}
      >
        <Gallery data={images} />
      </Link>
      <ProductTag 
        data={card_tags}
        customClasses="absolute top-1.5 left-1.5"
      />
      <WishlistButton 
        pk={pk}
        gtagEvent={{
          name,
          pk,
          price,
          category,
        }} 
      />
    </CardHeader>
  );
};

export default Header;
